import { gql } from "@apollo/client";

export const GET_NEWS_GENERATION_RECORD_QUERY = gql`
  query GetNewsArticle($newsId: String!, $tenantId: String!) {
    getNewsArticle(newsId: $newsId, tenantId: $tenantId) {
      newsId
      title
      content
      source
      url
      publishedDate
      status
      score
      enrichedData
      timestamp
      tenantId
    }
  }
`;
